import { RouteHead } from '@/components/seo/RouteHead';
import { ROUTES } from '@/routes';
import { LegalContent } from './LegalContent';

export default function PrivacyPage() {
  return (
    <>
      <RouteHead
        path={ROUTES.privacy}
        titleKey="seo:privacy.title"
        descriptionKey="seo:privacy.description"
      />
      <LegalContent slug="privacy" />
    </>
  );
}
